<template>
  <abbr
    :title="`${title} (Click for Glossary)`"
    @click.stop="onClickAbbr"
  >
    <slot v-if="!full" />
    <span v-else>{{ title }}</span>
  </abbr>
</template>

<script>
import contentful from '@/plugins/contentful'

export default {
  props: {
    full: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      title: null,
      term: null
    }
  },
  async mounted () {
    this.term = this.$slots.default[0].text

    const entries = await contentful.getEntries({
      'fields.id': this.term,
      content_type: 'glossary',
      limit: 1
    })

    this.title = entries.items.length ? `${entries.items[0].fields.term}` : null
  },
  methods: {
    onClickAbbr () {
      if (this.title) {
        this.$openHelpMenu(`${this.term}:glossary`)
      }
    }
  }
}
</script>
